import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from '../_services/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  isLoading = false;
  constructor(private loader: LoaderService, private ref: ChangeDetectorRef) {}

  ngOnInit() {
    this.loader.getLoaderState().subscribe((data) => {
      this.isLoading = data.load;
      this.ref.detectChanges();
    });
  }
}
